export default __webpack_public_path__ + "static/media/search_banner.3493e4d7.svg";